export default {
  type: "divider",
  data: {
    paddingTop: 10,
    paddingBottom: 10,
    align: "center",
    height: 2,
    width: 100,
    style: "solid",
    color: { r: 204, g: 204, b: 204, a: 1 },
  },
  children: [],
};
